import type { IconSvgObject } from './types';

const CornerRightUpIcon: IconSvgObject = [
  ["path", { d: "M10 9.00195L15 4.00195L20 9.00195M15 5.00195L15 17.002C15 18.6588 13.6569 20.002 12 20.002H4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerRightUpIcon;
